<template>
  <div class="error_404">
    <img class="bg" src="@/assets/img/error404/bg.png" alt="" />
    <div class="main">
      <span>您还可以：</span>
      <div class="btn">
        <button @click="goHome">
          <img src="@/assets/img/error404/shouye.png" alt="" />
          <span>返回首页</span>
        </button>
        <button @click="goBack">
          <img src="@/assets/img/error404/fanhui.png" alt="" />
          <span>返回上一步</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error404",
  methods: {
    created(){
      this.$router.push("/");

    },
    goHome() {
      this.$router.push("/");
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.error_404 {
  position: relative;

  width: 100vw;
  height: 100vh;

  font-family: Microsoft YaHei;
  font-size: 16px;
  font-weight: 400;

  color: rgba(36, 186, 88, 1);
  background-color: #fff;

  .bg {
    width: 100%;
    height: 100%;
  }

  .main {
    display: flex;

    position: absolute;
    bottom: 30%;
    left: 50%;

    width: 370px;
    height: 86px;

    transform: translateX(-185px);

    flex-direction: column;

    .btn {
      display: flex;

      justify-content: space-between;

      button {
        display: flex;

        margin-top: 30px;
        border: 1px solid rgba(36, 186, 88, 1);
        border-radius: 6px;
        width: 160px;
        height: 40px;

        background-color: #fff;

        outline: none;

        cursor: pointer;

        align-items: center;
        justify-content: center;

        span {
          margin-left: 17px;

          color: rgba(36, 186, 88, 1);
        }
      }
    }
  }
}
</style>
